import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconProjector24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="projector">
            <path
                d="M2.29297 4.29297C2.65908 3.92685 3.23809 3.90426 3.63086 4.22461L3.70703 4.29297L5.70703 6.29297L5.77539 6.36914C6.09574 6.76191 6.07315 7.34092 5.70703 7.70703C5.34092 8.07315 4.76191 8.09574 4.36914 7.77539L4.29297 7.70703L2.29297 5.70703L2.22461 5.63086C1.90426 5.23809 1.92685 4.65909 2.29297 4.29297Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M8 6V3C8 2.44772 8.44772 2 9 2C9.55229 2 10 2.44772 10 3V6C10 6.55228 9.55229 7 9 7C8.44772 7 8 6.55228 8 6Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M14.3691 4.22461C14.7619 3.90426 15.3409 3.92685 15.707 4.29297C16.0731 4.65909 16.0957 5.23809 15.7754 5.63086L15.707 5.70703L13.707 7.70703C13.3165 8.09756 12.6835 8.09756 12.293 7.70703C11.9024 7.31651 11.9024 6.68349 12.293 6.29297L14.293 4.29297L14.3691 4.22461Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11 13C11 11.8954 10.1046 11 9 11C7.89543 11 7 11.8954 7 13C7 14.1046 7.89543 15 9 15C10.1046 15 11 14.1046 11 13ZM13 13C13 15.2091 11.2091 17 9 17C6.79086 17 5 15.2091 5 13C5 10.7909 6.79086 9 9 9C11.2091 9 13 10.7909 13 13Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M1 18V14C1 13.2044 1.3163 12.4415 1.87891 11.8789C2.44151 11.3163 3.20435 11 4 11H6.16992L6.27246 11.0049C6.77663 11.0562 7.16992 11.4823 7.16992 12C7.16992 12.5177 6.77663 12.9438 6.27246 12.9951L6.16992 13H4C3.73478 13 3.48051 13.1054 3.29297 13.293C3.10543 13.4805 3 13.7348 3 14V18L3.00488 18.0986C3.02757 18.3276 3.12883 18.5429 3.29297 18.707C3.48051 18.8946 3.73478 19 4 19H20C20.2652 19 20.5195 18.8946 20.707 18.707C20.8946 18.5195 21 18.2652 21 18V14C21 13.7348 20.8946 13.4805 20.707 13.293C20.5195 13.1054 20.2652 13 20 13H11.8301C11.2778 13 10.8301 12.5523 10.8301 12C10.8301 11.4477 11.2778 11 11.8301 11H20C20.7957 11 21.5585 11.3163 22.1211 11.8789C22.6837 12.4415 23 13.2043 23 14V18C23 18.7957 22.6837 19.5585 22.1211 20.1211C21.5585 20.6837 20.7957 21 20 21H4C3.20435 21 2.44151 20.6837 1.87891 20.1211C1.38671 19.6289 1.08291 18.9835 1.01465 18.2969L1 18Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M18 15C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H16C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15H18Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
